module.exports = __webpack_public_path__ + "img/arrow-gray.3f983a26.svg";